var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5425 21.6568L17.8856 16L23.5425 10.3431C24.0629 9.8227 24.0629 8.97794 23.5425 8.45751C23.022 7.93708 22.1773 7.93708 21.6569 8.45751L16 14.1144L10.3431 8.45751C9.82271 7.93708 8.97796 7.93708 8.45753 8.45751C7.9371 8.97794 7.9371 9.8227 8.45753 10.3431L14.1144 16L8.45753 21.6568C7.93615 22.1782 7.9371 23.022 8.45753 23.5425C8.97796 24.0629 9.82177 24.0638 10.3431 23.5425L16 17.8856L21.6569 23.5425C22.1782 24.0638 23.022 24.0629 23.5425 23.5425C24.0629 23.022 24.0638 22.1782 23.5425 21.6568Z",
    fill: "#29173B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.6e826eaf731224206bd87ad5d4cd4cfe.svg";
export { ForwardRef as ReactComponent };